import { OptionType } from "../components/booking/information/FormSelect";

export function normalizeLabel(s: string) {
  return s
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}

export function ageFromYmd(dobStr: string): number | null {
  const m = dobStr.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})$/);
  if (!m) return null;
  const [_, yStr, mStr, dStr] = m;
  const dob = new Date(Number(yStr), Number(mStr) - 1, Number(dStr));
  if (isNaN(dob.getTime())) return null;

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  if (
    today.getMonth() < dob.getMonth() ||
    (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
  ) {
    age--;
  }
  return age;
}

export function findByKeywords(
  options: OptionType[],
  keywords: string[]
): OptionType | undefined {
  const kws = keywords.map(normalizeLabel);
  for (const opt of options) {
    const norm = normalizeLabel(opt.label);
    if (kws.some((k) => norm.includes(k))) return opt;
  }
  return undefined;
}
